import { trpc } from '@/shared/api';

export const useBusinessProfileQuery = () =>
  trpc.users.getBusinessProfile.useQuery(undefined, { retry: false });
